
var acc = document.getElementsByClassName("Accordion");
var accCallOut = document.getElementsByClassName("DrawerItem");

var i;
for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
        let iconPlus = this.childNodes[1].childNodes[1]
        let iconCross = this.childNodes[1].childNodes[3]

        this.classList.toggle("Active");
        let panel = this.nextElementSibling;

        if (panel.style.maxHeight) {

            panel.style.maxHeight = null;
            iconPlus.style.display = "block"
            iconCross.style.display = "none"

        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
            iconPlus.style.display = "none"
            iconCross.style.display = "block"
        }
    });
}

for (i = 0; i < accCallOut.length; i++) {
    accCallOut[i].addEventListener("click", function () {
        let calloutTitle = this.childNodes[1];
        let calloutPanel = this.childNodes[3];
        this.classList.toggle("active");
        let panel = this.querySelector(".panel");

        if (calloutPanel.style.maxHeight) {
            calloutPanel.style.maxHeight = null;
            calloutTitle.classList.add("DrawerTitleActive")
            calloutTitle.classList.remove("DrawerTitleActive")

        } else {
            calloutPanel.style.maxHeight = panel.scrollHeight + "px";

            calloutTitle.classList.remove("DrawerTitleActive")
            calloutTitle.classList.add("DrawerTitleActive")

        }
    });
}
